module.exports = __webpack_public_path__ + "img/4.0dc96dc0.jpeg";